import { FC } from "react";
import { useLocation, useParams } from "react-router-dom";
import SettingsUsersPage from "@/pages/settings/users/users.page";
import SettingsUserDetailsPage from "@/pages/settings/users/user.page.detail";
import SettingsProfilesPage from "@/pages/settings/profiles/profiles.page";
import SettingsInterfacesPage from "@/pages/settings/interfaces/interfaces.page";
import SettingsImportPage from "@/pages/settings/import/import.page";
import InterfacesTransaction from "./interfaces/InterfacesTransaction";
import OrganizationUnitsManagementList from "./organizationUnitsManagement/organizationUnitsManagementList";
import EmployeeGroupsManagementList from "./employeeGroupsManagement/employeeGroupsManagementList";

const SettingsPage: FC = () => {
    const { userId } = useParams();
    const { interfaceId } = useParams();
    const location = useLocation();
    function getComponent(pathname: string) {
        switch (pathname) {
            case "/settings/manage-users":
                return <SettingsUsersPage />;
            case "/settings/manage-users/user/" + userId:
                return <SettingsUserDetailsPage />;
            case "/settings/manage-profiles":
                return <SettingsProfilesPage />;
            case "/settings/manage-interface":
                return <SettingsInterfacesPage />;
            case "/settings/manage-import":
                return <SettingsImportPage />;
            case "/settings/manage-interface/transactions/" + interfaceId:
                return <InterfacesTransaction />;
            case "/settings/manage-organization-units":
                return <OrganizationUnitsManagementList />;
            case "/settings/manage-employee-groups":
                return <EmployeeGroupsManagementList />;
        }
    }
    return (
        <div key="settings_page_content" className="settings_page_content">
            {getComponent(location.pathname)}
        </div>
    );
};

export default SettingsPage;
